var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M54.8,210.5c-3.1,3.1-7.6,3.5-10.2,0.9c-2.6-2.6-2.1-7.1,0.9-10.2L201.2,45.5c3.1-3.1,7.6-3.5,10.2-0.9c2.6,2.6,2.1,7.1-0.9,10.2L54.8,210.5z M136,83l-12.8,12.8c-14.2,2.1-25.3,13.2-27.4,27.4l-12.8,12.8c-0.5-2.6-0.7-5.3-0.7-8c0-25.3,20.5-45.8,45.9-45.8C130.7,82.2,133.4,82.5,136,83z M128,62.5c-57.2,0-92.2,48.4-102.9,65.6c4.9,7.9,15,22.4,30,35.7l-9.4,9.4C22,151.8,10,128,10,128s39.6-78.7,118-78.7c13,0,24.9,2.2,35.8,5.8l-10.7,10.7C145.3,63.7,137,62.5,128,62.5z M120,173.1l12.8-12.8c14.2-2.1,25.3-13.2,27.4-27.4l12.8-12.8c0.5,2.6,0.7,5.3,0.7,8c0,25.3-20.5,45.8-45.9,45.8C125.3,173.8,122.6,173.5,120,173.1z M128,193.6c57.4,0,92.4-48.5,102.9-65.6c-4.8-7.9-15-22.4-30-35.8l9.4-9.4C234.1,104.2,246,128,246,128s-39.3,78.7-118,78.7c-13,0-24.9-2.2-35.8-5.8l10.6-10.6C110.7,192.3,119.1,193.6,128,193.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.10a5ac5d3f83f9be330d8d0606141799.svg";
export { ForwardRef as ReactComponent };